import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import { Button, ButtonGroup } from './FormElements';
// NOTE: removido chamada direta ao Asaas aqui — somente enviaremos o cadastro ao SGF
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle
} from './ui/alert-dialog';

const FormContainer = styled.div`
  width: 100%;
`;

const Description = styled.p`
  margin-bottom: 2rem;
  font-size: 0.95rem;
  color: ${props => props.theme.colors.lightText};
  line-height: 1.6;
`;

const SummarySection = styled.div`
  margin-bottom: 1.75rem;
`;

const SectionTitle = styled.h4`
  font-size: 1rem;
  margin: 0 0 0.75rem 0;
  color: ${props => props.theme.colors.lightText};
  font-weight: 600;
  text-transform: uppercase;
`;

const SummaryGrid = styled.div`
  display: grid;
  grid-template-columns: ${({ columns = 2 }) => `repeat(${columns}, minmax(0, 1fr))`};
  gap: 12px 16px;

  @media (max-width: ${props => props.theme.breakpoints.tablet}) {
    grid-template-columns: 1fr;
  }
`;

const SpacedSummaryGrid = styled(SummaryGrid)`
  margin-top: 12px;
`;

const SummaryItem = styled.div`
  background: ${props => props.theme.colors.lightBackground};
  border: 1px solid ${props => props.theme.colors.border};
  border-radius: 8px;
  padding: 10px 12px;
  grid-column: ${props => props.fullWidth ? '1 / -1' : 'auto'};
`;

const ItemLabel = styled.div`
  font-size: 0.75rem;
  text-transform: uppercase;
  color: ${props => props.theme.colors.lightText};
  margin-bottom: 4px;
`;

const ItemValue = styled.div`
  font-size: 0.95rem;
  color: ${props => props.theme.colors.text};
  word-break: break-word;
  white-space: pre-wrap;
`;

const PaymentScreen = ({ formData, prevStep, submitForm }) => {
  const [showDialog, setShowDialog] = useState(false);
  const [isCreatingCustomer, setIsCreatingCustomer] = useState(false);

  // Debug: Verificar variáveis de ambiente ao montar componente
  useEffect(() => {
    console.group('🔍 Debug - Variáveis de Ambiente');
    console.log('REACT_APP_URL_ASAAS:', process.env.REACT_APP_URL_ASAAS);
    console.log('REACT_APP_APIKEY_ASAAS existe?', !!process.env.REACT_APP_APIKEY_ASAAS);
    console.log('REACT_APP_APIKEY_ASAAS length:', process.env.REACT_APP_APIKEY_ASAAS?.length);
    console.log('REACT_APP_APIKEY_ASAAS primeiros 20 chars:', process.env.REACT_APP_APIKEY_ASAAS?.substring(0, 20));
    console.log('Todas variáveis REACT_APP:', Object.keys(process.env).filter(k => k.startsWith('REACT_APP')));
    console.groupEnd();
  }, []);

  const handleSubmit = (e) => {
    e.preventDefault();
    setShowDialog(true);
  };

  const handleConfirmSubmit = async () => {
    setShowDialog(false);
    setIsCreatingCustomer(true);

    try {
      // Envia apenas os dados para o SGF — não criamos cliente Asaas aqui
      console.log('� Enviando cadastro para o SGF (sem criar cliente Asaas):', formData);
      try {
        await submitForm(formData);
        console.log('✅ Dados enviados para API SGF com sucesso');
      } catch (sgfError) {
        console.warn('⚠️ Erro ao enviar para API SGF (payload será salvo localmente pelo serviço):', sgfError.message);
        // O sgfService já persiste localmente quando o backend está indisponível.
      }

      setIsCreatingCustomer(false);
    } catch (error) {
      console.error('❌ Erro ao enviar dados para SGF:', error);
      setIsCreatingCustomer(false);
      alert(`Erro ao enviar cadastro: ${error.message}\n\nVerifique o console para mais detalhes.`);
    }
  };

  const handleCancelSubmit = () => {
    setShowDialog(false);
  };

  const isStartup = Boolean(formData.is_startup);

  return (
    <FormContainer>
      <Description>
        Confira todos os dados antes de enviar. Caso precise alterar alguma informação, utilize o botão Voltar.
      </Description>

      <form onSubmit={handleSubmit}>
        <SummarySection>
          <SectionTitle>Contato</SectionTitle>
          <SummaryGrid columns={3}>
            <SummaryItem>
              <ItemLabel>Email</ItemLabel>
              <ItemValue>{formData.email_responsavel || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Celular/WhatsApp</ItemLabel>
              <ItemValue>{formData.celular_zap_responsavel || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Cargo</ItemLabel>
              <ItemValue>{formData.cargo_responsavel || 'Não informado'}</ItemValue>
            </SummaryItem>
          </SummaryGrid>
        </SummarySection>

        <SummarySection>
          <SectionTitle>Dados da Empresa</SectionTitle>
          <SummaryGrid>
            <SummaryItem>
              <ItemLabel>Nome da Empresa</ItemLabel>
              <ItemValue>{formData.nome_fantasia || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>CNPJ</ItemLabel>
              <ItemValue>{formData.cnpj || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Website</ItemLabel>
              <ItemValue>{formData.website || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>É uma Startup?</ItemLabel>
              <ItemValue>{isStartup ? 'Sim' : 'Não'}</ItemValue>
            </SummaryItem>
          </SummaryGrid>
        </SummarySection>

        <SummarySection>
          <SectionTitle>Endereço</SectionTitle>
          <SummaryGrid columns={3}>
            <SummaryItem>
              <ItemLabel>CEP</ItemLabel>
              <ItemValue>{formData.cep || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Rua</ItemLabel>
              <ItemValue>{formData.rua || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Número</ItemLabel>
              <ItemValue>{formData.numero || 'Não informado'}</ItemValue>
            </SummaryItem>
          </SummaryGrid>
          <SpacedSummaryGrid columns={3}>
            <SummaryItem>
              <ItemLabel>Complemento</ItemLabel>
              <ItemValue>{formData.complemento || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Cidade</ItemLabel>
              <ItemValue>{formData.cidade || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem>
              <ItemLabel>Estado</ItemLabel>
              <ItemValue>{formData.estado || 'Não informado'}</ItemValue>
            </SummaryItem>
          </SpacedSummaryGrid>
        </SummarySection>

        <SummarySection>
          <SectionTitle>Descrição</SectionTitle>
          <SummaryGrid columns={1}>
            <SummaryItem fullWidth>
              <ItemLabel>Breve descrição da empresa</ItemLabel>
              <ItemValue>{formData.breve_descricao || 'Não informado'}</ItemValue>
            </SummaryItem>
            <SummaryItem fullWidth>
              <ItemLabel>Produtos/Serviços</ItemLabel>
              <ItemValue>{formData.filiada_produtos_servicos || 'Não informado'}</ItemValue>
            </SummaryItem>
          </SummaryGrid>
        </SummarySection>

        <ButtonGroup>
          <Button type="button" onClick={prevStep} disabled={isCreatingCustomer}>
            Voltar
          </Button>
          <Button type="submit" primary disabled={isCreatingCustomer}>
            {isCreatingCustomer ? 'Processando...' : 'Finalizar e escolher o plano'}
          </Button>
        </ButtonGroup>
      </form>

      <AlertDialog open={showDialog} onOpenChange={setShowDialog}>
        <AlertDialogContent>
          <AlertDialogHeader>
            <AlertDialogTitle>Confirmar envio</AlertDialogTitle>
            <AlertDialogDescription>
              Deseja enviar suas informações?
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel onClick={handleCancelSubmit}>
              Cancelar
            </AlertDialogCancel>
            <AlertDialogAction onClick={handleConfirmSubmit}>
              Enviar
            </AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </FormContainer>
  );
};

export default PaymentScreen;